import { createBrowserClient } from "@supabase/ssr";

export function createClient() {
  return createBrowserClient(
    "https://xbqgwuvdqxtnbdqriogf.supabase.co",
    "sb_publishable_NfINKFxpbUQEkw98WDEngA_7DvUdeVq",
  );
}
